import React, { ComponentProps, useContext } from 'react';

import CloseButton from '@adsk/alloy-react-close-button';
import theme from '@adsk/alloy-react-theme';

import ModalContext from '../ModalContext';

type Props = ComponentProps<typeof CloseButton>;

const Close = React.forwardRef<HTMLButtonElement, Props>(
  (
    {
      style,
      className,
      onClick,
      showEscapeLabel: showEscapeLabelProp,
      ...props
    },
    ref,
  ) => {
    const context = useContext(ModalContext);

    const showEscapeLabel =
      showEscapeLabelProp !== undefined
        ? showEscapeLabelProp
        : context?.shouldCloseOnEsc;

    return (
      <CloseButton
        {...props}
        ref={ref}
        className={className}
        showEscapeLabel={showEscapeLabel}
        style={[
          {
            marginTop: theme.spacing.XXS,
            padding: 0,
          },
          style,
        ]}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          onClick && onClick(e);
        }}
      />
    );
  },
);

Close.displayName = 'Close';

Close.propTypes = {
  ...CloseButton.propTypes,
};

export default Close;
